import React, { useState, useMemo, forwardRef } from 'react';
import { SubMenuItem } from './SubMenuItem';

import { Link as RouterLink } from 'react-router-dom';

import {
    ListItem,
    ListItemIcon,
    Icon,
    ListItemText,
    Collapse,
    List,
    useTheme
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

const MenuItem = ({ label, icon, submenus, isOpen = true, to }) => {
    const [open, setOpen] = useState(false);

    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;
    const handleClick = () => {
        setOpen(!open);
    };

    const isSubmenu = (open) => {
        return open ? <ExpandLess /> : <ExpandMore />;
    };

    const renderLink = useMemo(
        () => forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
        [to],
    );
    const listItemTextStyles = {
        color: primaryColor, // Establece el color del tema como color del texto
    };
    return (
        <>
            <ListItem button onClick={handleClick} component={renderLink}>
                {icon ? (
                    <ListItemIcon>
                        <Icon style={{ color: primaryColor }}>{icon}</Icon>
                    </ListItemIcon>
                ) : null}
                  <ListItemText  style={listItemTextStyles} primary={label} />
                {isOpen && submenus.length !== 0 ? isSubmenu(open) : ''}
            </ListItem>
            {<Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {submenus.map((sub) => {
                        return <SubMenuItem {...sub} key={sub.id} />;
                    })}
                </List>
            </Collapse>}
        </>
    );
};

export default MenuItem;
